import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to top whenever the route pathname changes.
// Hash-only changes (#anchor) are left alone so in-page anchors keep working.
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            let tries = 0;
            const t = setInterval(() => {
                const el = document.getElementById(hash.slice(1));
                if (el || ++tries > 20) { clearInterval(t); el?.scrollIntoView({ behavior: "smooth", block: "start" }); }
            }, 100);
            return () => clearInterval(t);
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);

    return null;
}
